import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { listMySorties } from '../../api/sorties';
import { useNavigate } from 'react-router-dom';
import TableCard from '../../components/TableCard';

const QrScanIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 7V5a2 2 0 0 1 2-2h2"/><path d="M17 3h2a2 2 0 0 1 2 2v2"/><path d="M21 17v2a2 2 0 0 1-2 2h-2"/><path d="M7 21H5a2 2 0 0 1-2-2v-2"/>
    <rect x="7" y="7" width="3" height="3"/><rect x="14" y="7" width="3" height="3"/><rect x="14" y="14" width="3" height="3"/><rect x="7" y="14" width="3" height="3"/>
  </svg>
);

const statutColor = (v) => ({ PENDING: '#faad14', ACCEPTED: '#3b82f6', REFUSED: '#e24b4a', RETURNED: '#3b6d11' }[v] || '#888');
const statutBg   = (v) => ({ PENDING: '#faeeda', ACCEPTED: '#e6f1fb', REFUSED: '#fcebeb', RETURNED: '#eaf3de' }[v] || '#f0f0f0');

export default function MySorties() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchAll = async () => {
    setLoading(true);
    try { const data = await listMySorties(); setRows(data); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchAll(); }, []);
  useEffect(() => {
    const id = setInterval(() => fetchAll(), 10000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const onRefresh = () => {
      fetchAll();
    };
    window.addEventListener('sorties:refresh', onRefresh);
    return () => window.removeEventListener('sorties:refresh', onRefresh);
  }, []);

  return (
    <div className="page">
      <TableCard label="Mes sorties" loading={loading} rows={rows}>
        {(pageRows) => (
        <table>
          <thead>
            <tr>
              <th>Destination</th>
              <th>Motif</th>
              <th>Sortie prévue</th>
              <th>Retour prévu</th>
              <th>Sortie effective</th>
              <th>Retour effectif</th>
              <th>Statut</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {pageRows.map((r) => {
              const isActive = r.date_sortie && !r.date_retour_effective;
              return (
                <tr key={r.id} className={isActive ? 'row-active' : ''}>
                  <td>{r.destination || '-'}</td>
                  <td style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis' }}>{r.motif || '-'}</td>
                  <td>{r.date_sortie_prevue ? dayjs(r.date_sortie_prevue).format('YYYY-MM-DD HH:mm') : '-'}</td>
                  <td>{r.date_retour_prevue ? dayjs(r.date_retour_prevue).format('YYYY-MM-DD HH:mm') : '-'}</td>
                  <td>{r.date_sortie ? dayjs(r.date_sortie).format('YYYY-MM-DD HH:mm') : '-'}</td>
                  <td>{r.date_retour_effective ? dayjs(r.date_retour_effective).format('YYYY-MM-DD HH:mm') : '-'}</td>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                      <span style={{ display: 'inline-flex', padding: '2px 8px', borderRadius: 6, fontSize: 10, fontWeight: 600, background: statutBg(r.statut), color: statutColor(r.statut) }}>{r.statut}</span>
                      {r.is_overdue && <span className="tag tag-red">En retard</span>}
                    </div>
                  </td>
                  <td>
                    <div className="actions-cell">
                      {r.statut === 'ACCEPTED' && !r.date_sortie && (
                        <button className="btn-primary" style={{ fontSize: 11, height: 26, padding: '0 10px', display: 'flex', gap: 5 }} onClick={() => navigate('/student/scan-qr')}>
                          <QrScanIcon /> Sortie QR
                        </button>
                      )}
                      {r.date_sortie && !r.date_retour_effective && r.statut !== 'RETURNED' && (
                        <button className="btn-primary" style={{ fontSize: 11, height: 26, padding: '0 10px', display: 'flex', gap: 5 }} onClick={() => navigate('/student/scan-qr')}>
                          <QrScanIcon /> Retour QR
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        )}
      </TableCard>
    </div>
  );
}
